var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(-299 -4026)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 18,
    height: 18,
    transform: "translate(299 4026)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M72.547,71.543H72l-.205-.171a4.539,4.539,0,0,0,1.06-2.914,4.428,4.428,0,1,0-4.41,4.457,4.582,4.582,0,0,0,2.906-1.063l.205.171v.548L74.974,76,76,74.971Zm-4.1,0a3.086,3.086,0,1,1,3.077-3.086A3.069,3.069,0,0,1,68.445,71.543Z",
    transform: "translate(238 3965)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.9a282896cde3fa552a90d56fea2ffc60.svg";
export { ForwardRef as ReactComponent };